export default __webpack_public_path__ + "static/2_2-626888cd5cd63a466af482b61f80bbc8.jpg";